import { BuyerSubscriptionsCheck } from '@gql/BuyerSubscriptionsCheck'
import { FragmentBuyerSubscriptionsItem } from '@gql/FragmentBuyerSubscriptionsItem'
import { BuyerSubscriptionMutation } from '@gql/BuyerSubscriptionMutation'

export function useBuyerSubscriptions(sellerId: () => string, options?: { fetchPolicy?: 'cache-first' | 'cache-only' | 'network-only' }) {
  const auth = useAuth()
  const data = shallowReactive({
    holder: undefined as undefined | gen.BuyerSubscriptionsItemFragment,
  })
  useReset(() => {
    data.holder = undefined
  })

  const checkId = (): { id: string } | undefined => {
    const id = sellerId()
    return id?.length && auth.value.isAuth ? { id } : undefined
  }

  const { recheck } = useMultigetDeboucePost<gen.BuyerSubscriptionsItemFragment, gen.BuyerSubscriptionsCheckQuery, gen.BuyerSubscriptionsCheckQueryVariables>({
    uniqueName: 'useSellerSubscribeCheck',
    fetchPolicy: () => options?.fetchPolicy,
    checkId,
    fragment: FragmentBuyerSubscriptionsItem,
    fragmentName: 'BuyerSubscriptionsItem',
    query: BuyerSubscriptionsCheck,
    vars: (ids) => ({ sellerIds: { ids } }),
    on: (doc) => (data.holder = doc),
  })
  const client = useApollo('post')

  useApolloWatchFragment<gen.BuyerSubscriptionsItemFragment>({
    client: () => client,
    from: () => {
      const id = checkId()?.id
      return id ? { __typename: 'BuyerSubscriptionsItem', id } : undefined
    },
    fragment: FragmentBuyerSubscriptionsItem,
    fragmentName: 'BuyerSubscriptionsItem',
    on: (doc) => {
      data.holder = doc
    },
  })

  return { recheck, doc: toRef(() => data.holder) }
}

export function useBuyerSubscriptionsMutation(input: gen.InputBuyerSubscription) {
  return useGqlMutate<gen.BuyerSubscriptionMutation, gen.BuyerSubscriptionMutationVariables>(BuyerSubscriptionMutation, {
    clientId: 'post',
    vars: { input },
  })
}
